import type { FC, ReactNode } from 'react'

import {
    createContext,
    useCallback,
    useContext,
    useMemo,
    useState
} from 'react'
import BookingDialog from '@/components/landing/booking-dialog'
import { useSmoothScroll } from '@/components/generals/smooth-scroll'

interface BookingApi {
    openBooking: () => void
}

interface BookingProviderProps {
    children: ReactNode
}

const BookingContext = createContext<BookingApi>({
    openBooking: () => {}
})

export const useBooking = (): BookingApi => useContext(BookingContext)

export const BookingProvider: FC<BookingProviderProps> = ({ children }): ReactNode => {
    const [open, setOpen] = useState(false)
    const { stop, start } = useSmoothScroll()

    const openBooking = useCallback((): void => {
        stop()
        setOpen(true)
    }, [stop])

    const closeBooking = useCallback((): void => {
        setOpen(false)
        start()
    }, [start])

    const value = useMemo<BookingApi>(() => ({ openBooking }), [openBooking])

    return (
        <BookingContext.Provider value={value}>
            {children}
            <BookingDialog open={open} onClose={closeBooking} />
        </BookingContext.Provider>
    )
}
